export type AbAutoTestsQuery = {
    aqa: boolean | null;
    experiment: string | null;
    variantName: string | null;
    experimentOptions: string | null;
    isEnabled: string | null;
};

export const getAbAutoTestsQuery = (search: string = window.location.search): AbAutoTestsQuery => {
    const searchParams = new URLSearchParams(search);

    return {
        aqa: searchParams.get('__dev') === 'aqa',
        experiment: searchParams.get('experiment'),
        variantName: searchParams.get('experiment_variant'),
        experimentOptions: searchParams.get('experiment_options'),
        isEnabled: searchParams.get('is_enabled'),
    } as const;
};
